import { shouldForwardProp } from "@mui/system";

export const shouldForwardPropHelper = (
  prop: PropertyKey,
  propsSet: Set<string>
) => shouldForwardProp(prop) && !propsSet.has(String(prop));
